import React from 'react';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import dvCurved from '../../img/dv-curved.svg';
import PricingTiers from './PricingTiers';
import CmsFooter from './CmsFooter';

class MqlPlusIntroduction extends React.Component {
  constructor(props) {
    super(props);

    this.getCurrentTeam = this.getCurrentTeam.bind(this);
  }
  getCurrentTeam() {
    let team =  this.props.teams.all.find(team => team.id === this.props.teams.currentTeam);

    if (!team) {
      team = {};
    }

    return team;
  }
  render() {
    const exampleLeadDataLimit = 8;
    const copy = this.props.custom_copy.data;
    const example = this.props.example_lead;

    const exampleLeads = this.props.example_lead.lead.fields
      .slice(0, exampleLeadDataLimit)
      .reduce((acc, curr) => {
        const last = acc[acc.length - 1];

        if (last.length === 2) {
          return [...acc, [curr]];
        }

        acc[acc.length - 1].push(curr);

        return acc;
      }, [[]]).map((row, index) => {
        const items = row.map((item, i) => (
          <div className="detail-table-item" key={i}>
            <div className="detail-table-definition">
              {item.name}
            </div>
            <div className="detail-table-value">
              {item.value}
            </div>
          </div>
        ));

        return <div className="detail-table-row" key={index}>{items}</div>;
      });

    const smallLeadCards = this.props.small_example_leads.leads.map((item, index) => {
      const titleClasses = [
        'lead-card__title',
        'lead-card__title--with-avatar',
        item.company_name.length > 23 ? 'lead-card__title--small' : '',
      ].join(' ');
      return (
      <div className={`l-dv__cloud-card l-dv__cloud-card-${index + 1} lead-card`} key={index}>
        <header className="lead-card__header">
          <div className="lead-card__avatar">
            <img alt="" src={item.logo} className="lead-card__avatar-img" />
          </div>
          <h1 className={titleClasses}>{item.company_name}</h1>
        </header>

        <div className="detail-table">
          <div className="detail-table-row is-last">
            <div className="detail-table-item">
              <div className="detail-table-definition">
                {item.market ? 'Market' : 'Speciality'}
              </div>
              <div className="detail-table-value">
                {item.market ? item.market : item.speciality}
              </div>
            </div>
            <div className="detail-table-item is-last">
              <div className="detail-table-definition">
                {item.revenue ? 'Revenue' : (item.employees ? 'Employees' : 'Practitioners')}
              </div>
              <div className="detail-table-value">
                {item.revenue ? item.revenue : (item.employees ? item.employees : item.practitioners)}
              </div>
            </div>
          </div>
        </div>
      </div>
    )});

    return (
      <div>
        <header className="l-dv__intro">
          <div className="l-dv__intro-desc">
            <h2 className="l-dv__intro-title t-dv-intro-header">Introducing MQL+ Leads</h2>

            <div className="l-dv__intro-sub">
              <p className="t-dv-intro-sub">{copy.body_paragraph}</p>
            </div>

            <div className="l-dv__intro-list">
              <ul className="hero-list">
                <li className="hero-list__item">{copy.feature1}</li>
                <li className="hero-list__item">{copy.feature2}</li>
                <li className="hero-list__item">{copy.feature3}</li>
              </ul>
            </div>

            <a href="mailto:cheryl@prospectpath.com" className="l-dv__intro-button btn btn--feature btn--lg">
              Contact us to activate MQL+
            </a>
          </div>
          <div className="l-dv__intro-lead">
            <div className="lead-card lead-card--fade">
              <header className="lead-card__header">
                <h1 className="lead-card__title">{example.lead.company_name}</h1>
              </header>

              <div className="lead-card__progress">
                <div className="progress-bar-graph">
                  <p className="detail-table-definition">Match Rating</p>
                  <div className="progress-bar-graph-details">
                    <div className="progress-bar-graph-match progress-bar-graph-match--secondary">
                      {example.lead.match_rating}% Match
                    </div>
                  </div>
                </div>
                <div className="progress-bar-graph-line">
                  <div style={{ width: `${example.lead.match_rating}%` }} className="progress-bar-graph-fill progress-bar-graph-fill--secondary" />
                </div>
              </div>

              <div className="detail-table">
                {exampleLeads}
              </div>

              <div className="lead-card__extension">
                +10&nbsp;additional&nbsp;data&nbsp;points
              </div>

              {/* <div className="lead-card__label badge">MQL+</div> */}
            </div>
          </div>
        </header>


        <section className="l-dv__cloud">
          <div className="l-dv__cloud-title">
            <h3 className="t-cloud-header">Add great leads like these to your pipeline&hellip;</h3>
          </div>

          {smallLeadCards}

          <a className="t-dv-intro-link" href="https://clearbit.com">Logos provided by Clearbit</a>
          <img alt="" className="l-dv__cloud-bg" src={dvCurved} />
        </section>

        <section className="l-dv__testimonial">
          <div className="l-dv__testimonial-title">
            <h3 className="t-dv-testimonial-header">Your competitors are taking leads and increasing sales...</h3>
            <div className="l-dv__testimonial-bg" />
          </div>
          <div className="l-dv__testimonial-quote">
            <div className="quote">
              <div className="quote__avatar">
                <img alt="" src="/images/testimonial-image.jpg" className="quote__avatar-img" />
              </div>
              <div className="quote__content">
                <div className="quote__text">
                  {copy.testimonial_body}
                  <cite className="quote__cite">{copy.testimonial_label}</cite>
                </div>
              </div>
            </div>
          </div>
        </section>

        <PricingTiers pricing={this.props.pricing} teamMarket={this.getCurrentTeam().market} />


        <div className="l-dv__divider" />

        <section className="l-dv__cta">
          <div className="l-dv__cta-title">
            <h3 className="t-dv-cta-header">Activate now for 30% more leads.</h3>
          </div>
          <div className="l-dv__cta-button">
            <a href="mailto:cheryl@prospectpath.com" className="l-dv__intro-button btn btn--feature btn--lg">
              Contact us to activate MQL+
            </a>
          </div>
        </section>
        <div className="l-footer-container">
          <CmsFooter/>
        </div>
      </div>
    );
  }
}

MqlPlusIntroduction.propTypes = {
  example_lead: PropTypes.object,
  small_example_leads: PropTypes.object,
  custom_copy: PropTypes.object,
  currentTeam: PropTypes.object,
  pricing: PropTypes.object,
};

MqlPlusIntroduction.defaultProps = {
  example_lead: {
    lead: {
      company_name: '',
      match_rating: 0,
      fields: [],
    },
  },
  small_example_leads: {
    leads: [],
  },
  custom_copy: {
    page: 'mql-plus-leads',
    data: {
      body_paragraph: '',
      feature1: '',
      feature2: '',
      feature3: '',
      testimonial_body: '',
      testimonial_label: '',
    },
  },
  currentTeam: {},
  pricing: {},
};

const mapStateToProps = state => ({
  pricing: state.mqlPlusPricing.data.pricing_tiers,
  example_lead: state.mqlPlusCopy.data.example_lead,
  small_example_leads: state.mqlPlusCopy.data.small_example_leads,
  new_label: state.mqlPlusCopy.data.new_label,
  custom_copy: state.mqlPlusCopy.data.custom_copy,
  teams: state.teams,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(MqlPlusIntroduction);
